import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import environment from "../../environment/environment";
const BASE_URL = `${environment.API}`;
//axios.defaults.headers.common.Authorization = `Bearer ${}`;

export const getMakes = createAsyncThunk(
  "makesModels/getMakes",
  async (params, { rejectWithValue }) => {
    try {
      params.authorization = localStorage.getItem("userToken");
      const response = await axios.post(
        `${BASE_URL}/VehicleMakeModel/getVehicleMakes`,
        params
      );
      const data = await response.data;
      return data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const getModels = createAsyncThunk(
  "makesModels/getModels",
  async (params, { rejectWithValue }) => {
    try {
      params.authorization = localStorage.getItem("userToken");
      const response = await axios.post(
        `${BASE_URL}/VehicleMakeModel/getVehiclesModels`,
        params
      );
      const data = await response.data;
      return data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const getMakeById = createAsyncThunk(
  "makesModels/getMakeById",
  async (params, { rejectWithValue }) => {
    try {
      params.authorization = localStorage.getItem("userToken");
      const response = await axios.post(
        `${BASE_URL}/VehicleMakeModel/getMakeData`,
        params
      );
      const data = await response.data;
      return data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const getModelById = createAsyncThunk(
  "makesModels/getModelById",
  async (params, { rejectWithValue }) => {
    try {
      params.authorization = localStorage.getItem("userToken");
      const response = await axios.post(
        `${BASE_URL}/VehicleMakeModel/getModelData`,
        params
      );
      const data = await response.data;
      return data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const saveMake = createAsyncThunk(
  "makesModels/saveMake",
  async (params, { rejectWithValue }) => {
    try {
      params.authorization = localStorage.getItem("userToken");
      const response = await axios.post(
        `${BASE_URL}/VehicleMakeModel/saveVehicleMake`,
        params
      );
      const data = await response.data;
      return data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const saveModel = createAsyncThunk(
  "makesModels/saveModel",
  async (params, { rejectWithValue }) => {
    try {
      params.authorization = localStorage.getItem("userToken");
      const response = await axios.post(
        `${BASE_URL}/VehicleMakeModel/saveVehicleModel`,
        params
      );
      const data = await response.data;
      return data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const checkMake = createAsyncThunk(
  "makesModels/checkMake",
  async (params, { rejectWithValue }) => {
    try {
      params.authorization = localStorage.getItem("userToken");
      const response = await axios.post(
        `${BASE_URL}/VehicleMakeModel/checkMakeExists`,
        params
      );
      const data = await response.data;
      return data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const checkModel = createAsyncThunk(
  "makesModels/checkModel",
  async (params, { rejectWithValue }) => {
    try {
      params.authorization = localStorage.getItem("userToken");
      const response = await axios.post(
        `${BASE_URL}/VehicleMakeModel/checkModelExists`,
        params
      );
      const data = await response.data;
      return data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);